import * as Mutation from './mutation-types'
import AgendaApi from "@/services/agendaApi";

export default {
  async createSchedule({commit, dispatch, state}) {
    try {
      dispatch('startLoading')
      await AgendaApi.create(state.scheduleConfig)
      dispatch('stopLoading')

      commit(Mutation.SET_API_ERRORS, [])
      commit(Mutation.RESET_SCHEDULE_CONFIG)
      commit(Mutation.LOAD_CONTENT_TIME, [])
      commit(Mutation.SET_CREATION_STEP, 5)
    } catch (error) {
      dispatch('stopLoading')
      commit(Mutation.SET_API_ERRORS, error.response.data.errors)
    }
  },

  async loadEditableScheduleConfig({commit, getters}) {
    try {
      const scheduleConfig = await AgendaApi.getScheduleConfig(getters.scheduleId)
      commit(Mutation.LOAD_EDITABLE_SCHEDULE_CONFIG, scheduleConfig)
      commit(Mutation.SET_API_ERRORS, [])
    } catch (error) {
      commit(Mutation.SET_API_ERRORS, error.response.data.errors)
    }
  },

  async getContentTime({commit, state}) {
    if (state.totalContentTime.length === 0) {
      const contentTime = await AgendaApi.getTempoTotalConteudo(state.scheduleConfig)
      commit(Mutation.LOAD_CONTENT_TIME, contentTime)
    }
  },

  async loadDisciplines({commit, state}) {
    if (state.disciplines.length === 0) {
      const disciplines = await AgendaApi.listarDisciplinasCursos()
      commit(Mutation.LOAD_DISCIPLINES, disciplines)
    }
  },

  async loadStudyMaterials({commit, state}) {
    if (state.studyMaterials.length === 0) {
      const materials = await AgendaApi.getMateriais()
      commit(Mutation.LOAD_STUDY_MATERIALS, materials)
    }
  },

  resetApiErrors({commit}) {
    commit(Mutation.SET_API_ERRORS, [])
  },

  setCreationStep({commit}, step) {
    commit(Mutation.SET_CREATION_STEP, step)
  },

  setIsUpdate({commit}, status) {
    commit(Mutation.SET_IS_UPDATE, status)
  },

  setScheduleColor({commit}, color) {
    commit(Mutation.SET_SCHEDULE_COLOR, color)
  },

  setScheduleCourses({commit, getters}, courses) {
    if (getters.scheduleCourses !== courses) {
      commit(Mutation.SET_SCHEDULE_MODULES, [])
    }
    commit(Mutation.SET_SCHEDULE_COURSES, courses)
  },

  setScheduleDailyStudyTime({commit}, time) {
    commit(Mutation.SET_SCHEDULE_DAILY_STUDY_TIME, time)
  },

  setScheduleDates({commit}, dateRange) {
    commit(Mutation.SET_SCHEDULE_DATES, dateRange)
  },

  setScheduleDisciplines({commit, getters}, disciplines) {
    if (getters.scheduleDisciplines !== disciplines) {
      commit(Mutation.SET_SCHEDULE_MODULES, [])
    }
    commit(Mutation.SET_SCHEDULE_DISCIPLINES, disciplines)
  },

  setScheduleId({commit}, id) {
    commit(Mutation.SET_SCHEDULE_ID, id)
  },

  setScheduleMaterials({commit}, materialsIds) {
    commit(Mutation.SET_SCHEDULE_MATERIALS, materialsIds)
  },

  setScheduleModules({commit, getters}, modulesIds) {
    if (getters.scheduleModules !== modulesIds) {
      commit(Mutation.LOAD_CONTENT_TIME, [])
    }
    commit(Mutation.SET_SCHEDULE_MODULES, modulesIds)
  },

  setScheduleWeekdays({commit}, weekdays) {
    commit(Mutation.SET_SCHEDULE_WEEKDAYS, weekdays)
  },

  async updateSchedule({commit, dispatch, state}) {
    try {
      dispatch('startLoading')
      await AgendaApi.update(state.scheduleConfig)
      dispatch('stopLoading')

      commit(Mutation.SET_API_ERRORS, [])
      commit(Mutation.LOAD_CONTENT_TIME, [])
      commit(Mutation.RESET_SCHEDULE_CONFIG)
      commit(Mutation.SET_CREATION_STEP, 5)
    } catch (error) {
      dispatch('stopLoading')
      commit(Mutation.SET_API_ERRORS, error.response.data.errors)
    }
  },
}
